import React, { useContext } from 'react';
import { Field, FieldRenderProps } from 'react-final-form';
import { Input, LocaleContext } from 'shared';
import { required } from 'utils/formValidators';

export const Name = () => {
  const localeContext = useContext(LocaleContext);

  return (
    <Field name="name" validate={required(localeContext.formatMessage({ id: 'FORM.REQUIRED' }))}>
      {({ input, meta }: FieldRenderProps<HTMLInputElement>) => (
        <Input
          label={localeContext.formatMessage({ id: 'APPLICATION.FORM.APP-NAME' })}
          input={input}
          meta={meta}
          className="application-form__name"
          maxLenght={60}
          charsCounter={true}
        />
      )}
    </Field>
  );
};
